import axios from "axios";
import RestService from "./rest.service";

const API_URL = process.env.REACT_APP_API_URL;

class consentService {
  consent() {
    return new Promise((fnResolve, fnReject) => {
      RestService.getConsent("app/consent").then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  acceptConsent(serial,accept) {
    const oData = {
      consent: serial,
      accept: accept,
    };
    return new Promise((fnResolve, fnReject) => {
      RestService.postConsent("app/consent", oData).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
}

export default new consentService();
